<div class="input-box-container">
    <img *ngIf="isImageEnabled && imageSrcLeft" [ngClass]="{'nav-icon': isNavButton}" src="{{imageSrcLeft}}" alt="input-icon"
     (click)="leftBtnClick()">
    <input type="{{type}}" placeholder="{{placeholder}}" [(ngModel)]="formModelInput" [maxlength]="maxLength"
    (keyup)="onKeyPress($event)">
    <app-poshvine-link *ngIf="isButtonEnabled" [labelText]="buttonText" [showIcons]="false" (click)="emitClickEvent(formModelInput)"></app-poshvine-link>
    <app-poshvine-chip *ngIf="isChipEnabled && chipText" [labelText]="chipText"
    [type]="chipType"></app-poshvine-chip>
    <ng-container *ngIf="isImageEnabled && imageSrcRight">
        <div class="flex-fill"></div>
        <img *ngIf="isImageEnabled && imageSrcRight" src="{{imageSrcRight}}" alt="input-icon"
        (click)="rightBtnClick()">
    </ng-container>
</div>
